import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App";
import Host from "./components/Host";
import Buzzer from "./components/Buzzer";
import Party from "./components/Party";
import PartyControl from "./components/PartyControl";
import Admin from "./components/Admin";

// Fonts
import "./fonts/korinna.ttf";
import "./fonts/Swiss921-BT_43276.ttf";

const container = document.getElementById("root");
const root = createRoot(container!);

const path = window.location.pathname;
const buzzMatch = path.match(/^\/buzz\/(\d)$/);

if (buzzMatch) {
  // Phone buzzer page for a specific team
  const teamIndex = parseInt(buzzMatch[1], 10);
  root.render(<Buzzer teamIndex={teamIndex} />);
} else if (path === "/host") {
  // Host control panel
  root.render(<Host />);
} else if (path === "/party/control") {
  // Casual-trivia phone controller (any phone that scans the on-screen QR)
  root.render(<PartyControl />);
} else if (path === "/party") {
  // Always-on casual trivia display — TV-style, QR for phone controllers
  root.render(<Party />);
} else if (path === "/admin" || path.startsWith("/admin/")) {
  // Question manager: edit party trivia and Jeopardy game data.
  // The secret is appended as a path segment: /admin/<secret>
  root.render(<Admin />);
} else {
  // Main game board
  root.render(<App />);
}
